import { engineComponent } from "neo-common";
import { HtmlElement } from "./HtmlElement";
import { ComponentTypes } from "../../Components/ComponentTypes";

/**
 * HtmlCanvasElement is used for replacing existing canvas to right layer in dom structure.
 * Example:
 * <HtmlCanvasElement CanvasId="canvas" Class="HtmlCanvasElement" />
 *
 * @class HtmlCanvasElement
 * @extends HtmlElement
 */
@engineComponent(ComponentTypes.HtmlElement)
export class HtmlCanvasElement extends HtmlElement {
    constructor() {
        // dont create instance. Instance will be attach with id from node
        super("");
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {
        super.create(node);

        /*
         * CanvasId is id in html document of targeting canvas.
         * @property CanvasId
         * @type string
         * @default null
         */
        if (node.hasAttribute("CanvasId")) {
            this.instance = document.getElementById(node.getAttribute("CanvasId"));
            if (this.instance == null) {
                if (DEBUG) {
                    this.log("ERROR no element with id: " + node.getAttribute("CanvasId"));
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no CanvasId");
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlCanvasElement.ts
 **/